import { useAuthWhoamiGet } from "@/api/useAuthWhoamiGet";
import { wmsLogs } from "@/api/wms/useWmsQuery";
import useFetcher from "@/hooks/useFetcher";
import { usePaginationStore } from "@/store/pagenation.store";
import { WlWithEslViewGet200ResponseRowsInnerActionTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";

export const useWmsLogsFetch = () => {
  const { currentPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
  }));
  const { data: user } = useAuthWhoamiGet();

  const query: any = {
    $and: [
      {
        actionType: {
          $eq: WlWithEslViewGet200ResponseRowsInnerActionTypeEnum.BATCH,
        },
      },
    ],
  };

  const { queryKey, queryFn } = wmsLogs.get({
    populate: ["locationName", "lot", "item", "batch"],
    query: query,
    page: currentPage,
    pageSize: 10,
  });

  if (user?.code) {
    query.$and.push({
      creatorUserCode: {
        $eq: user.code,
      },
    });
  }

  const { data, Fetcher } = useFetcher({
    queryKey: queryKey,
    queryFn: queryFn,
  });

  return { data, Fetcher };
};
